export const API_URL = import.meta.env.VITE_BFF_BASE_URL;
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY;
export const ENVIROMENT = import.meta.env.VITE_ENVIROMENT;